function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Bulma from '../core';
import Plugin from '../plugin';
/**
 * @module Calendar
 * @since  0.3.0
 * @author  Thomas Erbe <vizuaalog@gmail.com>
 */

var Calendar = /*#__PURE__*/function (_Plugin) {
  _inherits(Calendar, _Plugin);

  var _super = _createSuper(Calendar);

  /**
   * Plugin constructor
   * @param  {Object} options Plugin instance's options
   * @return {this} The newly created instance
   */
  function Calendar(options) {
    var _this;

    _classCallCheck(this, Calendar);

    _this = _super.call(this, options);
    /**
     * The root Calendar element.
     * @type {HTMLElement}
     */

    _this.element = Bulma.createElement('div', ['calendar']);
    /**
     * The input element this calendar belongs to.
     * @type {HTMLElement|null}
     */

    _this.isInput = _this.parent.nodeName === 'INPUT';
    /**
     * The current date for today tests
     * @type {Date}
     */

    _this.now = new Date();
    /**
     * The date this calendar starts at
     * @type {Date}
     */

    _this.date = _this.option('date');
    /**
     * The current year for the calendar
     * @type {int}
     */

    _this.year = _this.date.getFullYear();
    /**
     * The current month for the calendar
     * @type {int}
     */

    _this.month = _this.date.getMonth();
    /**
     * Month names
     * @type {Array}
     */

    _this.months = _this.option('months');
    /**
     * Short day names
     * @type {Array}
     */

    _this.shortDays = _this.option('shortDays');
    /**
     * Number of days in each month
     * @type {Array}
     */

    _this.monthDays = [31, _this.isLeapYear(_this.year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    /**
     * Show the navigating buttons
     * @type {boolean}
     */

    _this.navButtons = _this.option('navButtons');
    /**
     * The format string for the date output. Used when attached to an input element.
     * @type {string}
     */

    _this.format = _this.option('format');
    /**
     * Should the calendar be shown as a modal. Used when attached to an input element
     * @type {boolean}
     */

    _this.overlay = _this.option('overlay');

    if (_this.overlay) {
      _this.buildModal();
    }

    if (_this.isInput) {
      _this.parent.addEventListener('focus', function (event) {
        _this.handleInputFocus(event);
      });
    }

    _this.render();

    return _this;
  } ////////////////////////////////////////
  ///// HELPER METHODS TO BUILD HTML /////
  ////////////////////////////////////////

  /**
   * If we are to show as an overlay, build the modal's HTML
   * @return {undefined}
   */


  _createClass(Calendar, [{
    key: "buildModal",
    value: function buildModal() {
      var _this2 = this;

      this.modal = Bulma.createElement('div', ['modal']);
      this.modalBackground = Bulma.createElement('div', ['modal-background']);
      var modalClose = Bulma.createElement('button', ['modal-close']);
      modalClose.addEventListener('click', function () {
        _this2.modal.classList.remove('is-active');
      });
      this.modal.appendChild(this.modalBackground);
      this.modal.appendChild(modalClose);
      this.element.appendChild(this.modal);
      this.element.style.zIndex = 40;
    }
    /**
     * Build the calendars nav HTML
     * @return {undefined}
     */

  }, {
    key: "buildNav",
    value: function buildNav() {
      var _this3 = this;

      var prevIcon, nextIcon;
      var nav = Bulma.createElement('div', 'calendar-nav');
      var navLeft = Bulma.createElement('div', 'calendar-nav-left');
      var navRight = Bulma.createElement('div', 'calendar-nav-right'); // Left side of nav (prev year/month buttons)

      if (this.navButtons) {
        this.prevYearButton = Bulma.createElement('button', ['button', 'is-text']);
        prevIcon = Bulma.createElement('i', ['fa', 'fa-backward']);
        this.prevYearButton.appendChild(prevIcon);
        this.prevYearButton.addEventListener('click', function (event) {
          _this3.handlePrevYearClick(event);
        });
        navLeft.appendChild(this.prevYearButton);
        this.prevMonthButton = Bulma.createElement('button', ['button', 'is-text']);
        prevIcon = Bulma.createElement('i', ['fa', 'fa-chevron-left']);
        this.prevMonthButton.appendChild(prevIcon);
        this.prevMonthButton.addEventListener('click', function (event) {
          _this3.handlePrevMonthClick(event);
        });
        navLeft.appendChild(this.prevMonthButton); // Right side of nav (next year/month buttons)

        this.nextMonthButton = Bulma.createElement('button', ['button', 'is-text']);
        nextIcon = Bulma.createElement('i', ['fa', 'fa-chevron-right']);
        this.nextMonthButton.appendChild(nextIcon);
        this.nextMonthButton.addEventListener('click', function (event) {
          _this3.handleNextMonthClick(event);
        });
        navRight.appendChild(this.nextMonthButton);
        this.nextYearButton = Bulma.createElement('button', ['button', 'is-text']);
        prevIcon = Bulma.createElement('i', ['fa', 'fa-forward']);
        this.nextYearButton.appendChild(prevIcon);
        this.nextYearButton.addEventListener('click', function (event) {
          _this3.handleNextYearClick(event);
        });
        navRight.appendChild(this.nextYearButton);
      } // Month/year label


      this.monthYearLabel = Bulma.createElement('div');
      this.monthYearLabel.innerHTML = this.months[this.month] + ' ' + this.year;
      nav.appendChild(navLeft);
      nav.appendChild(this.monthYearLabel);
      nav.appendChild(navRight);
      return nav;
    }
    /**
     * Build the calendar's container HTML
     * @return {HTMLElement} The calendar's container
     */

  }, {
    key: "buildContainer",
    value: function buildContainer() {
      return Bulma.createElement('div', 'calendar-container');
    }
    /**
     * Build the calendar's header HTML
     * @return {HTMLElement} The calendar's header element
     */

  }, {
    key: "buildHeader",
    value: function buildHeader() {
      var calendarHeader = Bulma.createElement('div', 'calendar-header');
      Bulma.each(this.shortDays, function (dayName) {
        var day = Bulma.createElement('div', 'calendar-date');
        day.innerHTML = dayName;
        calendarHeader.appendChild(day);
      });
      return calendarHeader;
    }
    /**
     * Build the calendar's body. This includes all days.
     * @return {HTMLElement} The calendar's body element
     */

  }, {
    key: "buildBody",
    value: function buildBody() {
      var _this4 = this;

      var calendarBody = Bulma.createElement('div', 'calendar-body');
      var daysInMonth = this.monthDays[this.now.getMonth()]; // Number of days to show from the previous month.

      var daysBefore = new Date(this.year, this.month, 1).getDay(); // Number of days to show from the next month

      var daysAfter;
      var numDays = daysInMonth + daysBefore;
      daysAfter = numDays;

      while (daysAfter > 7) {
        daysAfter -= 7;
      }

      numDays += 7 - daysAfter;
      var cells = [];

      for (var i = 0; i < numDays; i++) {
        var d = new Date(this.year, this.month, 1 + (i - daysBefore));
        var today = false;
        var thisMonth = false;

        if (d.getFullYear() === this.now.getFullYear() && d.getMonth() === this.now.getMonth() && d.getDate() === this.now.getDate()) {
          today = true;
        }

        if (d.getMonth() === this.month) {
          thisMonth = true;
        }

        cells.push({
          day: d.getDate(),
          isToday: today,
          isThisMonth: thisMonth
        });
      }

      Bulma.each(cells, function (day) {
        var d = Bulma.createElement('div', 'calendar-date');

        if (!day.isThisMonth) {
          d.classList.add('is-disabled');
        }

        var button = Bulma.createElement('button', 'date-item');

        if (_this4.isInput && day.isThisMonth) {
          button.addEventListener('click', function (event) {
            _this4.handleDayClick(event, day);
          });
        }

        if (day.isToday) {
          button.classList.add('is-today');
        }

        button.innerHTML = day.day;
        d.appendChild(button);
        calendarBody.appendChild(d);
      });
      return calendarBody;
    } //////////////////////////
    ///// EVENT HANDLERS /////
    //////////////////////////

    /**
     * Called when the input box is in focus.
     * @return {undefined}
     */

  }, {
    key: "handleInputFocus",
    value: function handleInputFocus() {
      if (this.overlay) {
        this.modal.classList.add('is-active');
      }

      this.parent.parentNode.insertBefore(this.element, this.parent.nextSibling);
    }
    /**
     * Event hander for when a day is clicked.
     * @param {Object} event The event object
     * @param {Object} day The day that was clicked
     * @return {undefined}
     */

  }, {
    key: "handleDayClick",
    value: function handleDayClick(event, day) {
      day = new Date(this.year, this.month, day.day);
      var dateString = this.formatDateString(day);
      this.parent.value = dateString;

      if (this.overlay) {
        this.modal.classList.remove('is-active');
      } else {
        this.parent.parentNode.removeChild(this.element);
      }
    }
    /**
     * Event handler for the previous month button.
     * @return {undefined}
     */

  }, {
    key: "handlePrevMonthClick",
    value: function handlePrevMonthClick() {
      this.month--;

      if (this.month < 0) {
        this.year--;
        this.month = 11;
      }

      this.render();
    }
    /**
     * Event handler for the next month button.
     * @return {undefined}
     */

  }, {
    key: "handleNextMonthClick",
    value: function handleNextMonthClick() {
      this.month++;

      if (this.month > 11) {
        this.year++;
        this.month = 0;
      }

      this.render();
    }
    /**
     * Event handler for the previous year button.
     * @return {undefined}
     */

  }, {
    key: "handlePrevYearClick",
    value: function handlePrevYearClick() {
      this.year--;
      this.render();
    }
    /**
     * Event handler for the next year button.
     * @return {undefined}
     */

  }, {
    key: "handleNextYearClick",
    value: function handleNextYearClick() {
      this.year++;
      this.render();
    }
    /**
     * Format the date based on the supplied format string.
     * @param {Object} day Date object representing the day to format
     * @returns {string} The formatted date string
     */

  }, {
    key: "formatDateString",
    value: function formatDateString(day) {
      var dateString = this.format; // May be a better/faster way of doing this?

      if (dateString.indexOf('yyyy') !== -1) {
        dateString = this.format.replace('yyyy', day.getFullYear());
      } else {
        dateString = this.format.replace('yy', day.getFullYear().toString().substr(-2));
      }

      if (dateString.indexOf('mm') !== -1) {
        var month = day.getMonth() + 1;

        if (month < 10) {
          month = '0' + month.toString();
        }

        dateString = dateString.replace('mm', month);
      } else {
        dateString = dateString.replace('m', day.getMonth() + 1);
      }

      if (dateString.indexOf('dd') !== -1) {
        var date = day.getDate();

        if (date < 10) {
          date = '0' + date.toString();
        }

        dateString = dateString.replace('dd', date);
      } else {
        dateString = dateString.replace('d', day.getDate());
      }

      return dateString;
    }
    /**
     * Clear the calendar HTML, ready for a re-render.
     * @return {undefined}
     */

  }, {
    key: "clearCalendar",
    value: function clearCalendar() {
      while (this.element.firstChild) {
        this.element.removeChild(this.element.firstChild);
      }
    }
    /**
     * Check if the passed year is a leap year.
     * @param {int} year The year to check against
     * @return {boolean} Is the year a leap year or not
     */

  }, {
    key: "isLeapYear",
    value: function isLeapYear(year) {
      // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    /**
     * Render/build the calendar's HTML.
     * @return {undefined}
     */

  }, {
    key: "render",
    value: function render() {
      this.clearCalendar();
      this.element.appendChild(this.buildNav());
      var container = this.buildContainer();
      container.appendChild(this.buildHeader());
      container.appendChild(this.buildBody());
      this.element.appendChild(container);

      if (this.overlay) {
        this.modal.insertBefore(this.element, this.modalBackground.nextSibling);
        this.parent.appendChild(this.modal);
      } else {
        this.parent.appendChild(this.element);
      }
    }
  }], [{
    key: "create",
    value:
    /**
     * Helper method used by the Bulma core to create a new instance.
     * @param  {Object} options The new calendar's options
     * @return {Calendar} The newly created calendar instance
     */
    function create(options) {
      return new Calendar(options);
    }
    /**
     * Returns a string containing the element class this plugin supports.
     * @returns {string} The class name.
     */

  }, {
    key: "getRootClass",
    value: function getRootClass() {
      return 'calendar';
    }
    /**
     * Returns an object containing the default options for this plugin.
     * @returns {object} The default options object.
     */

  }, {
    key: "defaultOptions",
    value: function defaultOptions() {
      return {
        date: new Date(),
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        navButtons: true,
        format: 'yyyy-mm-dd',
        overlay: false
      };
    }
  }]);

  return Calendar;
}(Plugin);

Bulma.registerPlugin('calendar', Calendar);
export default Calendar;